import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input,
    OnDestroy,
} from '@angular/core';
import { tap, map, startWith, switchMap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackbarService } from '../../core/services/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';

import {
    TableResponseQuery,
    FilterOutputModel,
    FiltersService,
} from '../../core';
import { GeneralService } from '../../core/services/general.service';
import { Subscription, of, Observable } from 'rxjs';
import {
    TableColumnDef,
    DataTypeEnum,
} from 'app/shared/tables/table-column-def';
import {
    CurrencyPipe,
    DecimalPipe,
    PercentPipe,
    DatePipe,
} from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';

/** A label for the range of items within the current page and the length of the whole list. */
const getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
        return `0 z ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
        startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} z ${length}`;
};

@Component({
    template: '',
    styleUrls: ['./main-table-new.component.scss'],
})
export class MainTableComponent implements OnInit, OnDestroy {
    // screen heigth to table view
    screenHeight: String;
    sortBy = '';
    selFilterValue: Array<FilterOutputModel> = [];
    // id field to edit, first in line in columnData
    idFieldName: string;
    // MatPaginator Output
    pageEvent: PageEvent;

    filterValue = '';
    itemsLength = 0;

    isLoadingResults = false;
    public isLoading = true;
    public totalRecords: number;

    data: any[] = [];
    public tableData: any[] = [];

    // pagination index'es
    pageIndex = 0;
    public pageSize = 100;
    lowValue = 0;
    highValue = 100;
    loadSubscription: Subscription;

    filterControl = new FormControl('');
    // NEW TABLE
    filterGlobalControl = new FormControl('');
    selectedColumnsControl = new FormControl([]);
    _paginator = null;

    @ViewChild(MatPaginator) // paginator: MatPaginator;
    // paginator: MatPaginator;
    // paginator: MatPaginator;
    set paginator(value: MatPaginator) {
        if (value) {
            this._paginator = value;
            value._intl.itemsPerPageLabel = 'Liczba elementów na stronie: ';
            value._intl.nextPageLabel = 'Następna strona';
            value._intl.previousPageLabel = 'Poprzednia strona';
            value._intl.getRangeLabel = getRangeLabel;
        }
    }

    get paginator(): MatPaginator {
        return this._paginator;
    }

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild('dt') dt: Table;

    @Input() dataService: any;
    @Input() columnsData: Array<TableColumnDef>;
    @Input() tableId: string;
    @Input() tableTitle: string = null;
    @Input() hasAddButton = false;
    @Input() isComp = false;
    @Input() canNavigate = false;
    @Input() navigationArr: Array<string> = [];

    @Input()
    set sortByField(field: string) {
        if (field) {
            this.sortBy = field;
        }
    }

    @Input()
    public isHeaderFormatUpperCase = false;

    @Input()
    public newTableMode = false;

    displayedColumns = [];
    selectedColumns: TableColumnDef[] = [];

    constructor(
        public router: Router,
        public snackBar: SnackbarService,
        public generalService: GeneralService,
        public dialog: MatDialog,
        protected currencyPipe: CurrencyPipe,
        protected decimalPipe: DecimalPipe,
        protected percentPipe: PercentPipe,
        protected datePipe: DatePipe,
        protected filtersService: FiltersService
    ) {
        // this.onResize();
    }

    ngOnInit(): void {
        // if (!this.filtersService.hasFiltersLoaded()) {
        //     this.filtersService
        //         .fetchFilters()
        //         .subscribe((response) =>
        //             this.filtersService.initFilters(response)
        //         );
        // }

        this.idFieldName = this.columnsData.shift().columnDef;
        this.displayedColumns = this.columnsData.map((c) => c.columnDef);

        this.setSelectedColumns();
        this.connectToDataSource();

        this.selectedColumnsControl.valueChanges.subscribe((val) => {
            if (this.selectedColumns.length > val.length) {
                const removedColumn: TableColumnDef = this.selectedColumns.filter(x => !val.includes(x))[0];
                this.dt.filter('', removedColumn.columnDef, 'contains');
            }

            this.selectedColumns = val;
            this.selectedColumnsChanged();
        });
    }

    ngOnDestroy(): void {
        // this.paginator.page.unsubscribe();
        if (this.loadSubscription) {
            this.loadSubscription.unsubscribe();
        }
    }

    selectedColumnsChanged() {
        if (this.dt.columnWidthsState) {
            this.dt.clearState();

            const oldColumnsWidth: string[] = this.dt.columnWidthsState.split(',');

            if (oldColumnsWidth.length < this.selectedColumns.length) {

                const totalLength = oldColumnsWidth.length;
                const numberToAdd = Math.round(100 / totalLength);

                const newColumnsWidth = oldColumnsWidth.map((val: string, index) => {
                    return (parseInt(val) - numberToAdd);
                });
                newColumnsWidth.push(numberToAdd * totalLength);

                this.dt.columnWidthsState = newColumnsWidth.join(',');
                this.dt.restoreColumnWidths();
            }
        }

        this.saveTableState();
        this.clearStateFromFilters();
    }

    protected reloadTable() {
        this.paginator._changePageSize(this.pageSize);
    }

    applyFilter(value: string) {
        // check if value changed
        // if (value === this.filterValue) return;
        this.filterValue = value.trim().toLowerCase();
        this.paginator.pageIndex = 0;
        this.paginator._changePageSize(this.pageSize);
        // this.loadPage();
    }

    public clearFilter() {
        this.filterControl.setValue('');
        this.applyFilter('');
    }

    public filterByTrigger() {
        this.applyFilter(this.filter.nativeElement.value);
    }

    loadPage() {
        if (this.newTableMode) {
            return;
        }

        this.loadSubscription = this.paginator.page
            .pipe(
                startWith({}),
                switchMap(() => {
                    this.isLoadingResults = true;
                    return (
                        this.dataService
                            .fetchData(
                                this.pageSize,
                                this.paginator.pageIndex * this.pageSize,
                                this.sortBy,
                                this.filterValue,
                                this.selFilterValue
                            )
                        // catch should be in this place to not break the pipe
                        // .catch((error) => this.messageOnFetchData(error))
                    );
                }),
                tap(() => (this.isLoadingResults = false)),
                map((data: TableResponseQuery) => {
                    this.itemsLength = data.total_count;
                    return data.items;
                })
            )
            .subscribe(
                (data: any[]) => (this.data = data),
                (err) => console.log(err)
            );
    }

    public messageOnFetchData(error): Observable<TableResponseQuery> {
        if (error.status !== 403) {
            this.snackBar.info('Wystąpił problem podczas pobierania danych.');
        }
        return of(new TableResponseQuery([], 0));
    }

    getPaginatorData(event: PageEvent): PageEvent {
        this.pageSize = event.pageSize;
        this.scrollTop();
        if (event.pageIndex === this.pageIndex + 1) {
            this.lowValue = this.lowValue + this.pageSize;
            this.highValue = this.highValue + this.pageSize;
        } else if (event.pageIndex === this.pageIndex - 1) {
            this.lowValue = this.lowValue - this.pageSize;
            this.highValue = this.highValue - this.pageSize;
        }
        this.pageIndex = event.pageIndex;

        return event;
    }

    public connectToDataSource() {
        setTimeout(() => this.loadPage(), 500);
    }

    public scrollTop() {
        // TODO: can be problem when 2 unselect-table on the same screen !!!
        // document.querySelector('mat-table').scrollTo({
        //     top: 0,
        //     behavior: 'smooth',
        // });
    }

    public navigateToPage(id: number) {
        this.router.navigate(['metadata/articles/add', id]);
    }

    public sortChange(e) {
        this.paginator.pageIndex = 0;
        this.sortBy = e.reversed ? e.selectedName + ' desc' : e.selectedName;
        this.paginator._changePageSize(this.pageSize);
    }

    public checkIfSelected(colName: string) {
        return this.sortBy.indexOf(colName) >= 0 ? true : false;
    }

    public notImplemented(row: any) {
        if (!this.canNavigate || !this.navigationArr.length) {
            // this.snackBar.info('Not implemented');
            // do nothing
        } else {
            this.router.navigate([
                ...this.navigationArr,
                row[this.idFieldName],
            ]);
        }
    }

    // need a function because exists two different columns:
    // ColumnDef and sortColumnDef(for columns with $expand)
    public selectSortName(column: any): string {
        return column.sortColumnDef ? column.sortColumnDef : column.columnDef;
    }

    openDialog(): void {
        this.snackBar.info('Not implemented');
    }

    public selFilterChanged(event: FilterOutputModel): void {
        const columnDef = this.columnsData.find(
            (c: TableColumnDef) => c.filterValue === event.filterName
        );

        const filter = this.selFilterValue.find(
            (el) => el.filterName === event.filterName
        );
        // if filters key was already in, then we should override else push
        if (
            filter &&
            !!filter.filterValues.length &&
            !!event.filterValues.length
        ) {
            filter.filterValues = event.filterValues;
        } else if (!event.filterValues.length) {
            const indexFilter = this.selFilterValue.findIndex(
                (fltr) => fltr.filterName === event.filterName
            );
            this.selFilterValue.splice(indexFilter, 1);
        } else {
            event.columnDef = columnDef;
            this.selFilterValue.push(event);
        }
        this.paginator.pageIndex = 0;
        this.paginator._changePageSize(this.pageSize);
    }

    public getTooltip(column: Object, row: any): string {
        try {
            switch (column['type']) {
                case 'date':
                    return row ? this.generalService.parseDate(row) : row;
                case 'vat':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(0)
                        : row;
                case 'margin':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(1)
                        : row;
                case 'number':
                    return row;
                default:
                    break;
            }
            switch (column['suffix']) {
                case 'currency':
                    return row ? row.toFixed(2) : row;
                default:
                    return row;
            }
        } catch (e) {
            console.log(e);
            console.log('error in type');
        }
    }

    // NEW TABLE
    public loadData(event: LazyLoadEvent) {
        event.globalFilter = this.filterGlobalControl.value;
        this.isLoading = true;

        // in a real application, make a remote request to load data using state metadata from event
        // event.first = First row offset
        // event.rows = Number of rows per page
        // event.sortField = Field name to sort with
        // event.sortOrder = Sort order as number, 1 for asc and -1 for dec
        // filters: FilterMetadata object having field as key and filter value, filter matchMode as value

        let sort = null;
        if (event.sortField !== undefined && event.sortField !== null) {
            sort = event.sortField + (event.sortOrder === 1 ? ' asc' : ' desc');
        }

        let filters: FilterOutputModel[] = [];
        if (event.filters !== undefined && event.filters !== null) {
            filters = Object.keys(event.filters)
                .map(
                    (e) =>
                        <FilterOutputModel>{
                            filterValues: [event.filters[e].value],
                            columnDef: this.columnsData.find(
                                (c: TableColumnDef) => c.columnDef === e
                            ),
                        }
                );
        }

        this.dataService
            .fetchData(
                event.rows,
                event.first,
                sort,
                event.globalFilter,
                filters
            )
            .subscribe(
                (d: TableResponseQuery) => {
                    this.tableData = d.items;
                    this.totalRecords = d.total_count;
                },
                (error: any) => {
                    this.messageOnFetchData(error);
                },
                () => {
                    this.isLoading = false;
                }
            );

        this.clearStateFromFilters();
    }

    // NEW TABLE
    public getFormattedData(
        columnData: any,
        columnDef: TableColumnDef
    ): string {
        let result = '';
        switch (columnDef.dataType) {
            case DataTypeEnum.Currency:
                result =
                    this.currencyPipe.transform(
                        columnData,
                        'PLN',
                        'symbol',
                        '.2-2'
                    ) || '-';
                break;
            case DataTypeEnum.Percent:
                result =
                    this.percentPipe.transform(
                        columnData,
                        columnDef.digitsInfo !== undefined
                            ? columnDef.digitsInfo
                            : '.0-0'
                    ) || '-';
                break;
            case DataTypeEnum.Date:
                result =
                    this.datePipe.transform(columnData, 'shortDate', 'UTC') ||
                    '-';
                break;
            default:
                result = columnData || '-';
                break;
        }
        return result;
    }

    // NEW TABLE
    public getFormattedHeader(header: string): string {
        if (this.isHeaderFormatUpperCase === true) {
            return header.toUpperCase();
        }

        return header;
    }

    // NEW TABLE
    public getColumnWidth(width: number): string {
        return `${width}%`;
    }

    // NEW TABLE
    // TODO: filtry powinny być ładowane tylko dla danej tabeli
    public getFilterOptions(filterDef: string): Observable<any> {
        //return this.filtersService.getFiltersByNameObservable(filterDef);
        return of('xx');
    }

    public clearGlobalFilter() {
        this.filterGlobalControl.reset();
        this.loadData(this.dt.createLazyLoadMetadata());
    }

    public onColReorder(event: { dragIndex: number, dragDrop: number, columns: TableColumnDef[] }) {
        this.saveTableState();
        this.clearStateFromFilters();
    }

    public onColResize(event: any) {
        this.clearStateFromFilters();
    }

    private clearStateFromFilters() {
        // Metoda this.dt.getStorage() tez jest zle ustawiona w kolejce...
        setTimeout(() => {
            const state = JSON.parse(localStorage.getItem(this.tableId));

            if (state && state.filters) {
                delete state.filters;

                localStorage.setItem(this.tableId, JSON.stringify(state));
            }
        }, 0);
    }

    private saveTableState() {
        // Zła kolejka po stronie Tabeli, setTImeout wyrzuca saveState na koniec wykonania
        setTimeout(() => {
            this.dt.saveState();
        }, 0);
    }

    private setSelectedColumns() {
        const tableSettings = JSON.parse(localStorage.getItem(this.tableId));

        if (tableSettings && tableSettings.columnOrder) {
            const selectedColumns = this.columnsData.filter((column) => {
                return !!tableSettings.columnOrder.find(col => col === column.field);
            });

            this.selectedColumns = selectedColumns;
            this.selectedColumnsControl.setValue(this.selectedColumns);
        } else {
            this.selectedColumns = this.columnsData;
            this.selectedColumnsControl.setValue(this.selectedColumns);
        }
    }
}
